<template>
  <div :class="{'is-icon': option.icon, 'is-pro': option.isPro && !isProUser}" class="tooltip-selector-option-icon">
    <div v-if="option.emoji && option.isInverse" class="avatar-svg-wrapper">
      <span :style="{'mask-image': `url(${option.emoji})`}" class="avatar-svg-icon" />
    </div>
    <img v-else-if="option.emoji" :src="option.emoji" :alt="option.label">
    <b-icon v-if="option.icon" :icon="option.icon" pack="fas" class="fa-2x" />
    <component v-else-if="option.component" :is="option.component" class="icon-component" />
  </div>
</template>

<script>
export default {
  name: 'TooltipSelectorOptionIcon',
  props: {
    option: {
      type: Object,
      required: true
    }
  },
  computed: {
    isProUser () {
      return this.$store.getters.isProUser
    }
  }
}
</script>

<style scoped lang="scss">
@import "~~/assets/css/components";

.tooltip-selector-option-icon {
  &:not(.is-icon) {
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;

    &.is-pro {
      height: 48px;
    }
  }
  :deep(.icon i::before) {
    color: $tooltip-selector-color;
  }
  .avatar-svg-wrapper {
    background-color: $tooltip-selector-color;
    .avatar-svg-icon {
      background-color: #fff;
    }
  }
}
</style>
